/**
 * @desc 盘点
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockOrderAdjustingCmd, options?: any) {
  return updateResponse(
    http(URL + `/stock/adjusting`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
